import type {ServiceManagementContentProps} from "./types.ts";
import type {ServiceManagementDetailProps} from "./types.ts";
import CustomButton from "@/shared/ui/customButton/CustomButton.tsx";

export const SERVICE_MANAGEMENT_CONTENT: ServiceManagementContentProps[] = [
    {
        id: 1,
        title: "Сервис для ЖК",
        description: "Платите за ЖКУ без комиссии, передавайте показания в один клик, вызывайте мастеров и участвуйте в жизни дома — всё в вашем смартфоне.",
        button: {
            component: CustomButton,
            text: "Войти в приложение для ЖК",
            className: "service-management__button",
            path: "/login"
        }
    },
    {
        id: 2,
        title: "Сервис для УК",
        description: "Единый портал для диспетчерской службы, руководства и бухгалтерии. Вся информация по дому, заявкам и платежам — в одном окне.",
        button: {
            component: CustomButton,
            text: "Войти в портал УК",
            className: "service-management__button",
            path: "/login"
        }
    },
    {
        id: 3,
        title: "Мобильное приложение и личный кабинет для жителей и портал для УК",
        description: "Почему выбирают нас?"
    }
];

export const SERVICE_MANAGEMENT_DETAILS: Record<number, ServiceManagementDetailProps[]> = {
    3: [
        {
            id: 1,
            title: "1. Снижение нагрузки на диспетчеров",
            detail: "Забудьте про вечно занятую линию. Жители описывают проблемы в заявках, сразу прикрепляя фото. Диспетчеру не нужно расшифровывать звонки — задача уже структурирована и готова к отправке бригаде."
        },
        {
            id: 2,
            title: "2. Прозрачность выполнения заявок",
            detail: "Контролируйте каждый этап: принято → в работе → выполнено. Вы видите, сколько времени мастера тратят на объекты, и можете оценивать эффективность сотрудников. Жители видят, что вы работаете, — это повышает доверие."
        },
        {
            id: 3,
            title: "3. Автоматизация финансов и отчетности",
            detail: "Начисляйте платежи, выгружайте квитанции и контролируйте сборы в пару кликов. Жители оплачивают онлайн — деньги поступают на счет УК быстрее. Никакой возни с наличными и банками."
        },
        {
            id: 4,
            title: "4. Понятная коммуникация с жильцами",
            detail: "Делайте рассылки (отключение воды, проверка счетчиков), публикуйте отчеты о расходах и новости дома. Больше никаких объявлений на подъездах, которые срывают ветром. Все важное — в телефоне у жителя."
        },
        {
            id: 5,
            title: "5. Прозрачность расходов",
            detail: "Каждая статья расходов фиксируется в системе. Жители видят, куда уходят их деньги. Это снимает вопросы и претензии, доказывая добросовестность вашей компании."
        }
    ]
};